import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import KlaroLogo from '@/components/haccp/KlaroLogo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { if (!token) toast.error('Link non valido'); }, [token]);

  const submit = async () => {
    if (password.length < 8) return toast.error('Password minimo 8 caratteri');
    if (password !== confirm) return toast.error('Le password non coincidono');
    setSubmitting(true);
    try {
      const r = await fetch(`${BACKEND_URL}/api/auth/reset-password`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, password }) });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.detail || 'Reset non riuscito');
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (e) { toast.error(e.message); } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="surface max-w-md w-full p-8">
        <KlaroLogo />
        {done ? (
          <div className="mt-6 text-center">
            <h1 className="font-heading text-2xl font-semibold text-emerald-600">Password aggiornata</h1>
            <p className="mt-2 text-sm text-[#475467]">Ora puoi accedere con la nuova password. Ti reindirizzo al login…</p>
          </div>
        ) : (
          <>
            <h1 className="mt-6 font-heading text-2xl font-semibold">Reimposta password</h1>
            <p className="mt-1 text-sm text-[#475467]">Scegli una nuova password di almeno 8 caratteri.</p>
            <div className="mt-5 space-y-4">
              <div><Label>Nuova password</Label><Input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} /></div>
              <div><Label>Conferma password</Label><Input data-testid="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
              <Button data-testid="reset-submit-btn" variant="success" className="w-full" onClick={submit} disabled={submitting || !token}>{submitting ? 'Aggiornamento…' : 'Aggiorna password'}</Button>
              <p className="text-center text-xs text-[#98A2B3]"><Link to="/login" className="hover:underline">← Torna al login</Link></p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
